import {
  ArrowDownCircle,
  ArrowUpCircle,
  CheckCircle2,
  Edit3,
  Info,
  PackageCheck,
  PackageX,
} from 'lucide-react';

// Słowniki dziedzinowe w jednym miejscu.
//
// Listy <option> dla typu i stanu kontenera były wcześniej wypisane osobno
// w formularzu i w filtrach — dodanie nowego typu wymagało pamiętania o obu
// miejscach. Statusy z kolei miały kolory rozsypane po łańcuchach warunków
// w trzech komponentach.

export const CONTAINER_TYPES = [
  { value: '20DC', label: "20' DC" },
  { value: '40DC', label: "40' DC" },
  { value: '40HC', label: "40' HC" },
  { value: '45HC', label: "45' HC" },
  { value: 'Reefer', label: 'Reefer' },
  { value: 'Open Top', label: 'Open Top' },
  { value: 'Flat Rack', label: 'Flat Rack' },
];

export const CONTAINER_CONDITIONS = [
  { value: 'Sprawny', label: 'Sprawny', tone: 'success' },
  { value: 'Uszkodzony', label: 'Uszkodzony', tone: 'danger' },
  { value: 'Wymaga naprawy', label: 'Wymaga naprawy', tone: 'warn' },
];

/** Stany traktowane jako "do naprawy" na pulpicie i w alertach. */
export const DAMAGED_CONDITIONS = ['Uszkodzony', 'Wymaga naprawy'];

export const STATUS = {
  GATE_IN_ADVISED: 'GATE-IN ADVISED',
  ON_STOCK: 'ON STOCK',
  GATE_OUT_ADVISED: 'GATE-OUT ADVISED',
  OUT_OF_STOCK: 'OUT OF STOCK',
};

/**
 * Metadane statusu: etykieta, kolor semantyczny i ikona.
 * `tone` odpowiada tokenom kolorów z index.css, więc badge automatycznie
 * wygląda poprawnie w obu motywach.
 */
export const STATUS_META = {
  [STATUS.GATE_IN_ADVISED]: {
    label: 'GATE-IN ADVISED',
    short: 'Awizowany wjazd',
    tone: 'info',
    icon: ArrowDownCircle,
  },
  [STATUS.ON_STOCK]: {
    label: 'ON STOCK',
    short: 'Na stocku',
    tone: 'success',
    icon: PackageCheck,
  },
  [STATUS.GATE_OUT_ADVISED]: {
    label: 'GATE-OUT ADVISED',
    short: 'Awizowany wyjazd',
    tone: 'warn',
    icon: ArrowUpCircle,
  },
  [STATUS.OUT_OF_STOCK]: {
    label: 'OUT OF STOCK',
    short: 'Wydany',
    tone: 'neutral',
    icon: PackageX,
  },
};

/** Statusy widoczne w widoku aktywnym (archiwum to wyłącznie OUT OF STOCK). */
export const ACTIVE_STATUSES = [
  STATUS.GATE_IN_ADVISED,
  STATUS.ON_STOCK,
  STATUS.GATE_OUT_ADVISED,
];

/**
 * Statusy oznaczające, że kontener FIZYCZNIE stoi na placu.
 *
 * Węższe niż ACTIVE_STATUSES: GATE-IN ADVISED to zapowiedź przyjazdu, więc taki
 * kontener jest aktywny w systemie, ale nie zajmuje jeszcze miejsca na terenie.
 * Mieszanie tych dwóch zbiorów daje na pulpicie dwie różne liczby pod tym samym
 * podpisem „na placu".
 */
export const ON_PLACE_STATUSES = [STATUS.ON_STOCK, STATUS.GATE_OUT_ADVISED];

export const getStatusMeta = (status) =>
  STATUS_META[status] || { label: status || 'Nieznany', short: '—', tone: 'neutral', icon: Info };

export const getConditionMeta = (condition) =>
  CONTAINER_CONDITIONS.find((item) => item.value === condition) || {
    value: condition,
    label: condition || '—',
    tone: 'neutral',
  };

// --- Historia zdarzeń -------------------------------------------------------

export const HISTORY_ACTION = {
  ADDED: 'Kontener Dodany',
  EDITED: 'Kontener Edytowany',
  GATE_IN_CONFIRMED: 'Wjazd Potwierdzony',
  GATE_OUT_ADVISED: 'Wyjazd Awizowany',
  GATE_OUT_CONFIRMED: 'Wyjazd Potwierdzony',
  DELETED: 'Przeniesiony do Kosza',
  RESTORED: 'Przywrócony z Kosza',
};

export const HISTORY_META = {
  [HISTORY_ACTION.ADDED]: { icon: Info, tone: 'info' },
  [HISTORY_ACTION.EDITED]: { icon: Edit3, tone: 'neutral' },
  [HISTORY_ACTION.GATE_IN_CONFIRMED]: { icon: ArrowDownCircle, tone: 'success' },
  [HISTORY_ACTION.GATE_OUT_ADVISED]: { icon: ArrowUpCircle, tone: 'warn' },
  [HISTORY_ACTION.GATE_OUT_CONFIRMED]: { icon: CheckCircle2, tone: 'info' },
};

export const getHistoryMeta = (action) =>
  HISTORY_META[action] || { icon: Info, tone: 'neutral' };

export const CURRENCIES = ['PLN', 'EUR', 'USD'];
